import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";

const Hero = () => {
  const [animationStage, setAnimationStage] = useState(0);

  useEffect(() => {
    const animationTimeline = [
      { stage: 1, delay: 300 }, // Logo appears
      { stage: 2, delay: 1000 }, // Tagline appears
      { stage: 3, delay: 1800 }, // Intro text appears
      { stage: 4, delay: 2800 }, // Buttons appear
    ];

    animationTimeline.forEach(({ stage, delay }) => {
      const timer = setTimeout(() => {
        setAnimationStage(stage);
      }, delay);

      return () => clearTimeout(timer);
    });
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="container">
        {/* Logo - Appears first */}
        <div
          className={`hero-logo ${animationStage >= 1 ? "animate-logo" : "pre-animate"
            }`}
        >
          <img src={logo} alt="Design Edge Logo" className="logo-image" loading="lazy" />
        </div>

        {/* Tagline - Appears second */}
        <h1
          className={`tagline ${animationStage >= 2 ? "animate-tagline" : "pre-animate"
            }`}
        >
          Design that sees beyond pixels.
        </h1>

        {/* Intro text - Appears third */}
        <p
          className={`intro ${animationStage >= 3 ? "animate-intro" : "pre-animate"
            }`}
        >
          Hi, I'm the Founder — Frontend Developer & Creative Designer.
        </p>

        {/* Buttons - Appear last */}
        <div
          className={`hero-buttons ${animationStage >= 4 ? "animate-buttons" : "pre-animate"
            }`}
        >
          <button
            className="btn btn-primary"
            onClick={() => scrollToSection("portfolio")}
          >
            View Our Work
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => scrollToSection("contact")}
          >
            Let's Talk
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
